import { EpicRefined } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import {
  CREATE_ADVISOR_MEETING,
  createAdvisorMeetingActionCreator,
  GetAdvisorTimeslotsAction,
  AdvisorMeetingActions,
} from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { mergeMap } from 'rxjs/operators'
import { of, merge } from 'rxjs'
import { ADVISOR_MEETINGS_URL } from 'interfaces/ajax'
import { advisorRequestQuestions } from 'components/features/coaching/advisorMeeting/fixtures/requestQuestions'
import FloatingPaneAction, { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { activateAnchorActionCreator, ActivateAnchor } from 'actions/navigationActions'
import { GetMeetingsInfoAction, AdvisorPageActions } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'

type ConsideredActions = AdvisorMeetingActions | AjaxCatchExtraActions | ActivateAnchor | FloatingPaneAction | AdvisorPageActions
export const createMeetingEpic: EpicRefined<ConsideredActions> = (action$, _, { post }) => action$.pipe(
  filterRequestOfType(CREATE_ADVISOR_MEETING, 'request'),
  mergeMap(({ payload }) => {
    const { params } = payload

    const { notes, topics, advisor_uid, timeslot } = params

    const body = {
      advisor_uid,
      timeslot,

      topics: {
        question: advisorRequestQuestions.topic.question,
        answer: topics || [],
      },
      notes: {
        question: advisorRequestQuestions.notes.question,
        answer: notes,
      },
    }

    return post(ADVISOR_MEETINGS_URL, { body }).pipe(
      mergeMap(({ response }) => {
        const { advisor, uid, ...restMeeting } = response

        return merge(
          of(new GetMeetingsInfoAction()),
          of(createAdvisorMeetingActionCreator.success(params, {
            advisor,
            meeting: {
              ...restMeeting,
              uid,
              advisorUid: advisor.uid,
            },
          })),
          of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'confirmed', uid, fields: params })),
        )
      }),
      ajaxCatch((error) => merge(
        of(createAdvisorMeetingActionCreator.error(params, error.status, error.xhr.response)),
        of(new GetAdvisorTimeslotsAction({ advisor_uid: params.advisor_uid })),
        of(activateAnchorActionCreator({
          anchor: 'advisor_timeslot',
          id: params.advisor_uid,
        }, {
          behavior: 'smooth',
          block: 'start',
        })),
        of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'schedule', fields: params })),
      ))
    )
  }),
)
